import { mutations as MUTATION, actions as ACTION } from "./types";
import { Api, ApiUrl } from "../../services";
import i18n from "@/i18n.js";

const actions = {
  [ACTION.INTEGRATION_FETCH_APPS](store) {
    const state = store.state.apps;

    state.loading = true;
    Api.base
      .get(ApiUrl.base.category.thirdParty)
      .then(res => {
        if (res && res.data) {
          state.fetched = true;
          state.loading = false;
          store.commit(MUTATION.INTEGRATION_FETCH_APPS, res.data.snippets);
        }
      })
      .catch(() => {
        state.loading = false;
        state.error = i18n.t("youtube.cantGetPlaylists");
      });
  }
};

export default actions;
